import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/messages/$conversationId')({
  loader: ({ params }) => {
    throw redirect({
      to: '/chat/$roomId',
      params: { roomId: params.conversationId },
      statusCode: StatusCodes.MOVED_PERMANENTLY,
    } as never)
  },
})
